import { render, staticRenderFns } from "./cmpConfirmPassword.vue?vue&type=template&id=4cdc9856&"
import script from "./cmpConfirmPassword.vue?vue&type=script&lang=js&"
export * from "./cmpConfirmPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports